/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import {
    OSD_MOVEMENT_TIME,
    OSD_STILL_TIME,
    PRIMARY_BRANDING_LOGO_DEFAULT_HEIGHT,
    PRIMARY_BRANDING_LOGO_DEFAULT_WIDTH,
} from '../../../config';
import { ServicesClientImpl } from '../../../core/impls/ServicesClientImpl';
import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { ImageLoader } from '../../ImageLoader';

import './AntiburnOsd.scss';

const AntiburnOsd: FunctionComponent = (): JSX.Element => {
    const [osdMovement, setOsdMovement] = useState({});
    const osdRef = useRef<HTMLDivElement>(null);
    const osdContainerRef = useRef<HTMLDivElement>(null);
    let interval;

    const primaryBrandingImageUrl = useRef('');

    useEffect(() => {
        const service = new ServicesClientImpl();

        primaryBrandingImageUrl.current = service.getPartnerBrandingImageUrl(
            PRIMARY_BRANDING_LOGO_DEFAULT_WIDTH,
            PRIMARY_BRANDING_LOGO_DEFAULT_HEIGHT,
        );
    }, []);

    const updateOsdPosition = () => {
        if (!osdContainerRef.current || !osdRef.current) return;
        const osdContainerHeight = osdContainerRef.current.offsetHeight;
        const osdContainerWidth = osdContainerRef.current.offsetWidth;
        const osdWidth = osdRef.current.offsetWidth;
        const osdHeight = osdRef.current.offsetHeight;

        const topMovement = Math.random() * (osdContainerHeight - osdHeight);
        const leftMovement = Math.random() * (osdContainerWidth - osdWidth);
        setOsdMovement({ top: `${topMovement}px`, left: `${leftMovement}px` });
    };

    useEffect(() => {
        setOsdMovement({ top: 'auto', left: 'auto' });
        const timer = setTimeout(() => {
            interval = setInterval(updateOsdPosition, OSD_MOVEMENT_TIME);
        }, OSD_STILL_TIME);
        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, []);

    return (
        <React.Fragment>
            <div
                className={'antiburn-container'}
                ref={osdContainerRef}
                data-testid="antiburn-container"
            >
                <div className="antiburn" style={osdMovement} ref={osdRef}>
                    <ImageLoader
                        src={primaryBrandingImageUrl.current}
                        data-testid="antiburn-branding-icon"
                    />
                    <div className="antiburn-message" data-testid="antiburn-message">
                        {Locale.getString(LocaleKeys.ANTIBURN_OSD_MESSAGE)}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AntiburnOsd;
